<template>
  <div class="filter-set">
    <div class="filter-name" @click.stop="$emit('toggle')" :class="boxClass">
      <span class="filter-name__label">Energialuokka</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </div>
    <expander :expanded="expanderVisible">
      <div class="chk-container">
        <div class="form-checkbox" v-for="energyClass in allClasses">
          <Checkbox
            :id="`energyClass-${energyClass}`"
            :label="energyClass"
            :value="energyClass"
            v-model="energyClassesModel"
          />
        </div>
      </div>
    </expander>
  </div>
</template>
<script setup lang="ts">
import Expander from '../expander/expander.vue';
import searchUtils from '@/app/utils/search-utils';
import { computed, type PropType } from 'vue';
import { useRouter } from 'vue-router';
import Checkbox from '@/app/components/form/checkbox.vue';
import type { EnergyClassificationType } from '@/schemas/filtersSchema';
import useSafeRoute from '@/app/composables/useSafeRoute';
const router = useRouter();
const route = useSafeRoute();

const allClasses: EnergyClassificationType[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
const { expanderVisible, energyClasses } = defineProps({
  expanderVisible: {
    type: Boolean,
    default: undefined,
  },
  energyClasses: {
    type: Array as PropType<EnergyClassificationType[]>,
    default: () => [],
  },
});
const energyClassesModel = computed({
  get() {
    return energyClasses;
  },
  set(value: string) {
    const updates = { energy: value };
    searchUtils.addFilterToUrl(router, route.value, updates);
  },
});

const boxClass = computed(() => (energyClasses?.length ? 'in-use' : ''));
</script>
<style scoped>
.chk-container {
  max-width: 200px;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, auto);
}
</style>
